// extracted by mini-css-extract-plugin
module.exports = {"appHeader":"AppHeader_appHeader__K1uC5","appNavbar":"AppHeader_appNavbar___MEcR"};